import React, { useState } from 'react';
import './styles.css';
import { Redirect } from 'react-router-dom';
import logo from './img/logo-title.png';
import QuickInfo from '../QuickInfo';
import AttractionsList from '../AttractionsList';
import Details from '../screens/Details';
import { render } from '@testing-library/react';
import { Fragment } from "react";

import { BrowserRouter as Router, Route } from "react-router-dom";

const SearchForm = (props) => {

    let clientDes = React.createRef();
    let clientType = React.createRef();
    const [redirect, setRedirect] = useState(false);
    const [destName, setDestName] = useState('');
    const [destType, setDestType] = useState('Domestic');

    const [authType, setAuthType] = useState(null);

    const { user } = props;


    
    const onPressSubmit = (event) => {
        event.preventDefault();
        fetch("./data/recommended_cities.json")
            .then(response => {
                return response.json();
            })
            .then(
                data => {
                    
                    // get client input data (destination name and type)
                    setDestName(cleanedDest(destName));

                    let currPlace = getPlace(data, destName);
                    let countriesMap = countryToCities(data);

                    let internationalRegions = ["South America", "Europe", "Asia", "Africa", "Ocenaia"];
                    let internationalCities = getIntCities(internationalRegions, countriesMap);

                    let foundCity = false; // bool to indicate if found city yet
                    let alertMsg = "[Incorrect City / Region Input] Please try again. Make sure you spelled city and select the correct region. Domestic Cities are any city in North America, while Internation Cities are regions outside of North America";
                    let northAmericaMap = new Map();
  
                    if (currPlace === 0) {  // city does not exist in dataset
                        alert("[City Does Not Exist] The city you input does not exist in our dataset. Please try again.");
                    } else if (destType === 'Domestic') { // domestic cities check
                        if (internationalCities.includes(currPlace.name.toLowerCase())) {
                            alert("[Wrong Type] This is a international city, please change to International option.");
                        } else {
                            northAmericaMap = countriesMap.get("North America");
                            let currCity = "";
                            for (let i = 0; i < northAmericaMap.length; i++) {
                                currCity = northAmericaMap[i].name;
                                if (currCity.toLowerCase() === currPlace.name.toLowerCase()) {
                                    foundCity = true;
                                    setRedirect(true);
                                }
                            }
            
                            if (!foundCity) {
                                alert(alertMsg);
                            }
                        }
                    } else { // check if international city in data set
                        northAmericaMap = countriesMap.get("North America");
                        if (northAmericaMap.includes(currPlace)) {
                            alert("[Wrong Type] This is a domestic city, please change to Domestic option.");
                        } else {
                            for (let i = 0; i < internationalRegions.length; i++) {
                                let currCountryArr = countriesMap.get(internationalRegions[i]);
                                for (let j = 0; j < currCountryArr.length; j++) {
                                    if (currCountryArr[j].name.toLowerCase() === currPlace.name.toLowerCase()) {
                                        foundCity = true;
                                        setRedirect(true);
                                    }
                                }
                            }

                            if (!foundCity) {
                                alert(alertMsg);
                            }
                        }
                    }
        })
    }

    function cleanedDest(str) {
        str = str.trim();
        let splitStr = str.toLowerCase().split(' ');
        for (let i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        // Directly return the joined string
        return splitStr.join(' '); 
     }

    function render(destName) {
        return <Redirect push to={`/details/${destName}`} />;
    }

    
    function getIntCities(internationalRegions, countriesMap) {
        let output = [];
        for (let i = 0; i < internationalRegions.length; i++) {
            let currCities = countriesMap.get(internationalRegions[i]);
            for (let j = 0; j < currCities.length; j++) {
                output.push(currCities[j].name.toLowerCase());
            }
        }
        return output;
    }


    function countryToCities(data) {
        let countries = new Map();
        for (let i = 0; i < data.length; i++) {
            countries.set(data[i].name, data[i].cities);
        }
        return countries;
    }

    function getPlace(data, city) {
        // returns array of info for the given city
        for (let i = 0; i < data.length; i++) {
            let contCities = data[i].cities;
            for (let j = 0; j < contCities.length; j++) {
                if (contCities[j].name.toLowerCase() === city.toLowerCase()) {
                    return contCities[j];
                }
            }
        }
        return 0;
    }


    const onPressAuth = (aType) => {
        setAuthType(aType)
    }

    if (authType) {
        return <Redirect push to={`/auth/${authType}`} />;
    }

    if (!redirect) {
        return (
            <div>
                <img className="logo" src={logo} alt="touristy page logo"></img>
                <div>
                </div>
                <div>
                    <ul id="nav">
                        <li><a href="/">Home</a></li>
                        <li><a href="/about">About</a></li>
                        <li><a href="/favorites">Favorites</a></li>
                        <li><a onClick={() => { onPressAuth('signIn')}}>Sign In</a></li>
                        <li><a onClick={() => { onPressAuth('signUp')}}>Sign Up</a></li>
                    </ul>
                </div>

                {/* <Router>
                    <Route path="/about"  component={About} />
                    <Route path="/contact"  component={Favorites} />
                </Router> */}

                <div id="mainbody">
                    <div id="background" alt="image of asian city">
                        <br></br><br></br><br></br><br></br>
                        {
                            user && (
                                <p id="slogan">{`Welcome ${user.email.substring(0, user.email.indexOf('@'))}!`}</p>
                            )
                        }
                        <p id="slogan">Travel for that "feel-good" feeling!</p>
                        <form id="form" onSubmit={(event) => onPressSubmit(event)}>
                            <input placeholder="Destination (Country or City)" id="destinationInput" onChange={(input) => {setDestName(input.target.value)}} />
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label>Choose Destination Type:</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <select ref={clientType} onChange={(input) => {setDestType(input.target.value)}}>
                                <option value="Domestic">Domestic</option>
                                <option value="International">International</option>
                            </select>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input className="button" type="submit" value="Submit" />
                        </form>
                        <br></br><br></br><br></br><br></br>
                    </div>
                </div>
            </div>
        );
    } else {
        window.location = `/details/${destName}`;
        
    }   
}


const About = (props) => {
    const [authType, setAuthType] = useState(null);

    const onPressAuth = (aType) => {
        setAuthType(aType)
    }

    if (authType) {
        return <Redirect push to={`/auth/${authType}`} />;
    }
    return (
        <div>
            <img className="logo" src={logo} alt="touristy page logo"></img>
            <div>
                <ul id="nav">
                    <li><a href="/">Home</a></li>
                    <li><a href="/about">About</a></li>
                    <li><a href="/favorites">Favorites</a></li>
                    {/* <li><a onClick={() => { onPressAuth('signIn')}}>Sign In</a></li>
                    <li><a onClick={() => { onPressAuth('signUp')}}>Sign Up</a></li> */}
                </ul>
            </div>
            <div style={{margin: '2em'}}>
                <h1>About</h1>
                <h4>Our Goals</h4>
                <p>
                    Touristy is an interactive travel recommendation app for users of all ages to experience the great places to 
                    travel around the world while being safe. In quarantine, each of our mental health take a hit,
                    and we feel that by traveling we can do what excites and find happiness and purpose. That is why we created 
                    a service that provides traveling information and a personal touch by recommending “authentic” local experience.

                    We hope our users, young college students deprived of traveling from the pandemic, can utilize this platform to
                    look for information regarding various travel destinations around the world. Our strategy of learning about our users
                    preferences, presenting travel data in a visually encapsulating way,
                    and authentic approach by incorporating our own recommendations will allow the users to thrive in their post-quarantine
                    vacation and achieve our goal of making our users <i>“travel safe and happy.”</i> We aim to bring
                    happiness and improvement in users’ mental health, especially after the pandemic. We believe that our app will be a unique
                    and inspiring platform for our users to find and do what excites them in their next chapter of their lives.
                </p>
            </div>
        </div>
    )

};



// Favorites Page
const Favorites = (props) => {
    const [authType, setAuthType] = useState(null);

    const onPressAuth = (aType) => {
        setAuthType(aType)
    }

    if (authType) {
        return <Redirect push to={`/auth/${authType}`} />;
    }
    return (
        <div>
            <img className="logo" src={logo} alt="touristy page logo"></img>
            <div>
                <ul id="nav">
                    <li><a href="/">Home</a></li>
                    <li><a href="/about">About</a></li>
                    <li><a href="/favorites">Favorites</a></li>
                    {/* <li><a onClick={() => { onPressAuth('signIn')}}>Sign In</a></li>
                    <li><a onClick={() => { onPressAuth('signUp')}}>Sign Up</a></li> */}
                </ul>
            </div>
            <div style={{margin: '2em'}}>
                <h1>Favorites</h1>
            </div>
        </div>
    )

};

export default SearchForm;